/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProductDto } from '../../models/backend-product-dto';

export interface OpexesProductsList$Params {
  /**
   * id Варианта
   */
  variant?: number;
}

export function opexesProductsList(
  http: HttpClient,
  rootUrl: string,
  params?: OpexesProductsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendProductDto>>> {
  const rb = new RequestBuilder(rootUrl, opexesProductsList.PATH, 'get');
  if (params) {
    rb.query('variant', params.variant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendProductDto>>;
    }),
  );
}

opexesProductsList.PATH = '/api/opexes/products/';
